export const IS_TOP_PAGE = 'IS_TOP_PAGE';
export const GET_SCHOOL_PATH = 'GET_SCHOOL_PATH';
export const IS_VEDIO_PAGE = 'IS_VEDIO_PAG';


// WEBPACK FOOTER //
// ./src/redux/type/Router.type.js